'use client';

import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

import ErrorView from '@/components/Error/Error';
import { MainLayout } from '@/components/Layouts/MainLayout';

const Error = ({ error }: { error: Error }) => {
  useEffect(() => {
    if (error) {
      datadogRum.addError(error);
      datadogRum.startSessionReplayRecording();
    }
  }, [error]);
  return (
    <MainLayout>
      <ErrorView />
    </MainLayout>
  );
};

export default Error;
